import AuthService from "../../utilities/services/auth.service";

import { SettlementReportWrapper } from "../../components";

export default function SettlementReportPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <>
      <SettlementReportWrapper organization={organization} />
    </>
  );
}
